import { Link } from 'react-router-dom';
import { Checkboxes, Details, Table } from 'nhsuk-react-components';
import { Notification } from 'schemas/Notification.schema.ts';
import {
  capitaliseFirstChar,
} from 'utils/formattingUtils.ts';
import './NotificationRow.scss';
import { DateTime } from 'luxon';

interface NotificationRowProps {
  notification: Notification;
  selected: boolean;
  onToggleSelected: () => void;
}

const ERROR_EVENT_TYPES = ['ingestion failure'];

function toAppPath(link: string): string {
  const { pathname, search, hash } = new URL(link, window.location.origin);
  return `${pathname}${search}${hash}`;
}

function NotificationRow({ notification, selected, onToggleSelected }: NotificationRowProps) {
  const isError = ERROR_EVENT_TYPES.includes(notification.type);
  const createdAt = DateTime.fromISO(notification.timestamp).setZone('Europe/London');

  return (
    <Table.Row>
      <Table.Cell
        style={{ paddingLeft: '15px' }}
      >
        <Checkboxes.Item
          id={`select-${notification.id}`}
          checked={selected}
          onChange={onToggleSelected}
          aria-label={`Select ${notification.type} notification for ${notification.entityName}`}
        >
          <div />
        </Checkboxes.Item>
      </Table.Cell>
      <Table.Cell>
        <div className="notification-row__content">
          <span className="notification-row__unread-dot" style={{ visibility: notification.read ? 'hidden' : 'visible' }} aria-hidden="true" />
          <div>
            <span className="nhsuk-u-font-weight-bold">
              {
                    capitaliseFirstChar(
                      notification
                        .type
                        .replace('nhs notify', 'NHS Notify'),
                    )
                }
            </span>
            <div className="nhsuk-u-secondary-text-colour">{capitaliseFirstChar(notification.entityName)}</div>
            {notification.details && (
              <Details>
                <Details.Summary>More details</Details.Summary>
                <Details.Text>
                  {isError
                    ? (
                      <span className="notification-row__error">
                        {notification.details}
                      </span>
                    )
                    : notification.details}
                </Details.Text>
              </Details>
            )}
          </div>
        </div>
      </Table.Cell>
      <Table.Cell>{notification.teamName}</Table.Cell>
      <Table.Cell>
        <time dateTime={notification.timestamp}>
          <span>{createdAt.toFormat('HH:mm')}</span>
          <br />
          <span>{createdAt.toFormat('dd LLL yyyy')}</span>
        </time>
      </Table.Cell>
      <Table.Cell>
        <Link
          to={toAppPath(notification.link)}
          aria-label={`View ${notification.type} notification for ${notification.entityName}`}
        >
          View
        </Link>
      </Table.Cell>
    </Table.Row>
  );
}

export default NotificationRow;
